// Create and setup your form here

<template>
  <div>
    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-bind:language="language"
      v-bind:progressbar="false"
      v-bind:standalone="true"
    >
      <question
        v-for="(question, index) in questions"
        v-bind="question"
        v-bind:key="'m' + index"
        v-model="question.model"
      >
      </question>

      <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <template v-slot:complete>
        <div class="f-section-wrap">
          <div v-if="questions[0].model === 'feeling_great'">
            <span class="f-tagline">Submit issue &gt; Step 3/3</span>
            <div v-if="loading">
              <span class="fh2">Please wait, submitting...</span>
            </div>
            <div v-else>
              <p class="f-description">
                <span
                  >Thank You 😊. We will verify your link and send out invites
                  soon. All the Best!!</span
                >
              </p>
            </div>
          </div>
          <div v-else>
            <span class="fh2">Hope that you will feel better, soon.😉</span>
            <p class="f-description"><span>Have a great day!</span></p>
          </div>
        </div>
      </template>
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit">
          <!-- Leave empty to hide default submit button -->
        </div>
      </template>
    </flow-form>
  </div>
</template>

<script>
// Import necessary components and classes
import { mapGetters } from "vuex";
import FlowForm from "@/components/vueFlow/components/FlowForm.vue";
import Question from "@/components/vueFlow/components/Question.vue";
import LanguageModel from "@/components/vueFlow//models/LanguageModel";

// If using the npm package, use the following line instead of the ones above.
// import FlowForm, Question, { LanguageModel } from '@ditdot-dev/vue-flow-form'

export default {
  name: "Shelf",
  components: {
    FlowForm,
    Question
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    })
  },
  data() {
    return {
      loading: false,
      completed: false,
      language: new LanguageModel(),
      questions: [
        {
          type: "multiplechoice",
          id: "multiple_choice",
          tagline: "Welcome to HeartBeatFam!",
          title: "Hi 👋, how are you feeling today?",
          multiple: false,
          required: true,
          helpTextShow: false,
          options: [
            {
              label: "Great",
              value: "feeling_great"
            },
            {
              label: "Not Well",
              value: "not_well"
            }
          ],
          jump: {
            feeling_great: "feeling_great",
            not_well: "_submit"
          },
          model: ""
        },
        {
          type: "text",
          id: "feeling_great",
          tagline: "",
          title: "Let us know how great you feel:",
          multiple: false,
          required: true,
          helpTextShow: false,
          description: "Here you'll find answers to",
          descriptionLink: [
            {
              url: "https://familyheartbeatcare.web.app/support",
              text: "FAQs",
              target: "_self"
            }
          ],
          options: [
            {
              label: "Yes, but I couldn’t find the answer",
              value: "faq_no"
            }
          ],
          placeholder: "I feel like doing jumping jacks",
          jump: {
            _other: "_submit"
          },
          model: ""
        }
      ]
    };
  },
  methods: {
    //TODO- Put in mixin: saveToDb, OnComplete, onSendData, getData
    saveToDb(dataFromForm, formId = "default", sessionCookieName = "default") {
      console.log("Aving1");

      const sessionCookie = "test cookies"; //this.checkSession(sessionCookieName);  -- //TODO understand this cookie

      const data = {
        form: {
          user: this.user ? this.user.uid : null,
          cookie: sessionCookie,
          ip: this.res ? (this.res.data ? this.res.data.ip : this.res) : null,
          data: dataFromForm
        },
        form_id: formId
      };
      console.log("Aving2");

      this.$store.dispatch("user/saveForm", data).then(() => {
        this.$emit("complete", dataFromForm);
      });
    },
    /* eslint-disable-next-line no-unused-vars */
    onComplete(completed, questionList) {
      // This method is called whenever the "completed" status is changed.
      this.completed = completed;

      // Set `submitted` to true so the form knows not to allow back/forward
      // navigation anymore.
      this.$refs.flowform.submitted = true;

      this.onSendData();
    },

    onSendData() {
      const self = this;
      const data = this.getData();

      this.loading = true;
      this.saveToDb(
        data,
        "onboard_authorpublisher_10062022",
        "signup_authorpublisher"
      );

      /*
        You can use Fetch API to send the data to your server, eg.:

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
      */

      setTimeout(() => {
        self.loading = false;
      }, 1500);
    },

    getData() {
      const data = {
        questions: [],
        answers: []
      };

      this.questions.forEach(question => {
        if (question.title) {
          let answer = question.model;
          if (Array.isArray(answer)) {
            answer = answer.join(", ");
          }

          data.questions.push(question.title);
          data.answers.push(answer);
        }
      });

      return data;
    },

    formatTicket(ticket) {
      return ticket && ticket.replace(/-/g, "");
    }
  }
};
</script>

<style lang="css" scoped>
@import "../_themes/theme-standard.css";
/* If using the npm package, use the following lines instead of the one above */
/* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css'; */
/* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-green.css'; */
</style>
